import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const TableSearchField = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
  InputProps = {},
  inputProps = {},
  sx = {},
  ...textFieldProps
}) => (
  <TextField
    {...textFieldProps}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    placeholder={placeholder}
    size="small"
    inputProps={{
      ...inputProps,
      "aria-label": ariaLabel || placeholder,
    }}
    InputProps={{
      ...InputProps,
      startAdornment: (
        <>
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
          {InputProps.startAdornment}
        </>
      ),
    }}
    sx={{
      width: { xs: "100%", md: 280 },
      "& .MuiOutlinedInput-root": {
        minHeight: 36,
        borderRadius: "999px",
        backgroundColor: "grey.100",
        "& fieldset": { borderColor: "transparent" },
        "&:hover fieldset": { borderColor: "grey.300" },
      },
      ...sx,
    }}
  />
);

export default TableSearchField;
